import { Link } from 'react-router-dom';
import { X, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSystemAnnouncements } from '../../contexts/SystemAnnouncementsContext';
import { AnnouncementAudience } from './AnnouncementInbox';

export default function AnnouncementBanner() {
  const value = useSystemAnnouncements();
  const { t } = useTranslation();
  if (!value?.enabled || !value.banner) return null;
  const { banner, store, actionPending, error } = value;
  return (
    <aside aria-label={t('announcements.important')} className={`flex items-start gap-3 border-b p-3 ${banner.severity === 'critical' ? 'border-red-300 bg-red-50 text-red-900 dark:bg-red-950 dark:text-red-100' : 'border-amber-300 bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-100'}`}>
      <AlertTriangle size={20} className="mt-0.5 shrink-0" aria-hidden="true" />
      <div className="min-w-0 flex-1 break-words">
        <p><AnnouncementAudience item={banner} /></p>
        <Link className="font-semibold underline" to={`/announcements/${banner.id}`}>{banner.title}</Link>
        {error && <p role="status" className="text-sm">{t('announcements.actionError')}</p>}
      </div>
      <button type="button" onClick={() => store.acknowledge(banner.id, true)} disabled={actionPending}
        aria-label={t('announcements.dismiss')} className="shrink-0 rounded p-1 hover:bg-black/10 focus-visible:outline-2">
        <X size={20} aria-hidden="true" />
      </button>
    </aside>
  );
}
